<template>
  <main>
    <md-card>
      <md-card-header>
        <div class="md-title">部門管理</div>
      </md-card-header>

      <md-card-content v-if="errorMessages.length">
        <div class="md-layout">
          <div class="md-layout-item md-size-100">
            <flash-message :errors="errorMessages"></flash-message>
          </div>
        </div>
      </md-card-content>
      <loading-spinner v-if="sending"></loading-spinner>
      <md-card-content v-else>
        <md-table v-if="groups.length">
          <md-table-row>
            <md-table-head><span>部門</span></md-table-head>
            <md-table-head><span>支払情報の名称</span></md-table-head>
            <md-table-head><span>決済方法</span></md-table-head>
            <md-table-head><span>送付方法</span></md-table-head>
            <md-table-head>
              <!-- PHASE3: 部門機能 -->
              <router-link v-if="!isTrialUser && isSuperUser()" :to="{name: 'BackendUserDepartmentNew'}">
                <md-button class="md-primary md-raised" :disabled="deleting">
                  <md-icon>add</md-icon>
                  <span>新規登録</span>
                </md-button>
              </router-link>
            </md-table-head>
          </md-table-row>
          <group-item v-for="(group, groupIndex) in groups" :group="group"
                      v-bind:key="'group-key-' + groupIndex"
                      :is-trial-user="isTrialUser" :deleting="deleting"
                      v-on:deleteConfirm="onDeleteConfirm"/>
        </md-table>
        <md-table v-else-if="sending === false">
          <md-table-row>
            <md-table-head><span>部門</span></md-table-head>
            <md-table-head>
              <!-- PHASE3: 部門機能 -->
              <router-link v-if="!isTrialUser && isSuperUser()" :to="{name: 'BackendUserDepartmentNew'}">
                <md-button class="md-primary md-raised" :disabled="deleting">
                  <md-icon>add</md-icon>
                  <span>新規登録</span>
                </md-button>
              </router-link>
            </md-table-head>
          </md-table-row>
          <md-table-row>
            <md-table-cell colspan="2">{{ noDataMessage }}</md-table-cell>
          </md-table-row>
        </md-table>
      </md-card-content>
    </md-card>

    <delete-modal
      :md-active.sync="showDeleteModal"
      md-title="部門削除の確認"
      :md-content="'以下の部門を削除します。<br><span>部門名: ' + deleteGroupName + '</span><br>よろしいですか？'"
      confirm-button-class="md-accent md-raised"
      cancel-button-class="md-raised"
      @md-cancel="onDeleteCancel"
      @md-confirm="onDeleteSubmit"/>
    <md-snackbar :md-active.sync="showSnackBar"
                 :md-duration="snackbarDuration"
                 @md-closed="showSnackBar = false">
      <span>{{ successMessage }}</span>
      <md-button class="md-primary" @click="showSnackBar = false">閉じる</md-button>
    </md-snackbar>
  </main>
</template>

<script>
  import {apiClientWithUserToken as apiClient, apiList} from '../../../modules/apiClient';
  import ValidationError                                from "../../../components/ValidationError";
  import GroupItem                                      from "../../../components/backend/user/GroupItem";
  import CommonMixin                                    from "../../../mixins/commonMixin";
  import Common                                         from "../../../modules/common";
  import DeleteModal                                    from "../../../components/DeleteModal";
  import FlashMessage                                   from "../../../components/FlashMessage";
  import LoadingSpinner                                 from "../../../components/LoadingSpinner";
  import axios                                          from "axios";

  export default {
    name      : "UserDepartments",
    components: {
      LoadingSpinner,
      FlashMessage,
      DeleteModal,
      GroupItem,
      ValidationError,
    },
    mixins    : [CommonMixin],
    data() {
      return {
        groups         : [],
        paymentMethods : [],
        deleteGroupId  : null,
        deleteGroupName: null,
        isTrialUser    : true,
        deleting       : false,
      };
    },
    mounted() {
      this.checkAccountStatus();
      this.getGroupList();
      this.getSnackBar();
    },
    methods   : {
      getGroupList() {
        const groupId = this.isGroupAdmin()
          ? Number(Common.getCurrentUserInfo().group.id)
          : null;
        this.sending = true;
        axios
          .all([
            apiClient.get(apiList.jon.groups.list),
            apiClient.get(apiList.payment.payment_methods.list),
          ])
          .then(axios.spread((...responses) => {
            const groupListResponse         = responses[0];
            const paymentMethodListResponse = responses[1];
            if (this.hasResponseErrors(groupListResponse)
              || this.hasResponseErrors(paymentMethodListResponse)) {
              return;
            }
            this.groups         = this.parsedGroups(groupListResponse.data.data, 0).filter(group => groupId === null || Number(group.group_id) === groupId);
            this.paymentMethods = paymentMethodListResponse.data.data;
            this.getUserPaymentMethodDetail();
          }))
          .catch(error => {
            this.errorMessages = [error.message];
          });
      },
      getUserPaymentMethodDetail() {
        const self     = this;
        const settings = self.groups.map((group, index) => {
          return apiClient
            .get(apiList.payment.settings.detail.replace(':group_id', group.group_id))
            .then(async function (response) {
              const settingsDetail              = response.data;
              self.groups[index].payment_method = self.paymentMethods.find(function (paymentMethod) {
                return paymentMethod.gmo_member_id === _.get(settingsDetail, 'payment_method.gmo_member_id');
              });
            })
            .catch(error => {
              self.errorMessages = [error.message];
            });
        });
        Promise.all(settings).then(() => {
          this.sending = false;
        });
      },
      checkAccountStatus() {
        apiClient.get(apiList.accounts.status)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            const status = response.data.status;
            if (status === Common.monthlyStatus) {
              this.isTrialUser = false;
            }
          })
          .catch(error => {
            this.errorMessages = [error.message];
          });
      },
      deleteGroup() {
        this.deleting = true;
        apiClient.delete(apiList.jon.groups.delete.replace(':group_id', this.deleteGroupId))
          .then(response => {
            this.showDialog = false;
            if (this.hasResponseErrors(response)) {
              return;
            }
            this.showSnackBar   = true;
            this.successMessage = Common.messages.group.deleteSuccess;
            this.getGroupList();
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.deleting = false;
          });
      },
      onDeleteConfirm(group) {
        this.deleteGroupName = group.name;
        this.deleteGroupId   = group.group_id;
        this.showDeleteModal = true;
      },
      onDeleteCancel() {
        this.deleteGroupName = null;
        this.deleteGroupId   = null;
        this.showDeleteModal = false;
      },
      onDeleteSubmit() {
        this.showDeleteModal = false;
        this.deleteGroup();
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
